<template>
    <div id="editUser">
        <el-container>
            <el-header>
                <top-Nav></top-Nav>
            </el-header>
            <el-main>
                <el-row>
                    <div style="height:56px;background:#ccc">
                        <div class="mainHead">
                            <div class="route">
                                <span class="crumbs"></span><span class="router_link" @click="linkIndex">用户管理</span><span class="arrow">></span><span>{{msg}}</span><span></span>
                            </div>
                            <div>
                                <el-button type="primary" @click="returnBtn()">返回</el-button>
                            </div>
                        </div>
                    </div>
                    <el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="demo-ruleForm">
                        <el-form-item label="用户姓名:" prop="userName" :required="true" :show-message="false" class="item_input">
                            <el-input v-model="ruleForm.userName" placeholder="长度不超过8个字符" :maxlength="8" @input="checkEmpty"></el-input>
                        </el-form-item>
                        <el-form-item label="用户工号:" prop="userNumber" :required="true" :show-message="false" class="item_input">
                            <el-input v-model="ruleForm.userNumber" placeholder="长度不超过14个字符的字母、数字或下划线" :maxlength="14" @input="checkEmpty"></el-input>
                        </el-form-item>
                        <el-form-item label="用户账号:" prop="loginName" :required="true" :show-message="false" class="item_input">
                            <el-input v-model="ruleForm.loginName" placeholder="长度为8~16位的字母、数字或下划线" :maxlength="16" @input="checkEmpty" :disabled="isEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号:" prop="userPhone" :required="true" :show-message="false" class="user_phone">
                            <el-input v-model="ruleForm.userPhone" placeholder="长度不超过11个字符的数字" :maxlength="11" @input="checkEmpty"></el-input>
                        </el-form-item>
                        <el-form-item label="启用状态:" prop="enabled" :required="true" :show-message="false" class="run_status">
                            <el-radio v-model="ruleForm.enabled" :label="false" @change="checkEmpty" :disabled="isSuperManger">启用</el-radio>
                            <el-radio v-model="ruleForm.enabled" :label="true" @change="checkEmpty" :disabled="isSuperManger">禁用</el-radio>
                        </el-form-item>
                        <div class="submit_userInfo">
                          <el-button type="primary" :disabled="disabled" @click="submitInfo('ruleForm')" v-if="isAuth('common:interface')">保存</el-button>
                        </div>
                    </el-form>
                </el-row>
            </el-main>
        </el-container>
    </div>
</template>
<script>
    import topNav from '../../components/TopNav.vue';
    import {ajaxFuncJson} from '@/api/ajax';
    export default {
        name: 'editUser',
        data() {
            return {
                msg: '编辑用户',
                ruleForm: {
                    userName: '',
                    userNumber: '',
                    loginName: '',
                    userPhone: '',
                    enabled: false,
                },
                editBasicUserInfo:{              //效验是否编辑内容已被修改
                  userName: '',
                  userNumber: '',
                  loginName: '',
                  userPhone: '',
                  enabled: false,
                },
                disabled:true,
                id:'',
                isSuperManger:false,
                isEdit:false,
            }
        },
        created(){
          if(this.$route.query.type==='add'){
            this.msg='新增用户';
            this.isEdit=false;
          }else {
            this.msg='编辑用户';
            this.isEdit=true;
            this.id=this.$route.query.id;
            this.getEditUserInfo();
            if(this.$route.query.runStatus==='0'){
                this.isSuperManger=true;
            }
          }
        },
        mounted() {

        },
        methods: {
            //返回按钮
            returnBtn(){
              if(this.$route.query.type==='add'){
                if(this.ruleForm.userName!==''||this.ruleForm.userNumber!==''||this.ruleForm.loginName!==''||this.ruleForm.userPhone!==''){
                  this.$confirm('本次新增内容尚未保存，确定退出吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                  }).then(() => {
                    this.$router.push({path:'/userManger'})
                  }).catch(() => {

                  });
                }else {
                  this.$router.push({path:'/userManger'})
                }
              }else {
                if(!this.disabled){
                  this.$confirm('本次编辑内容尚未保存，确定退出吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                  }).then(() => {
                    this.$router.push({path:'/userManger'})
                  }).catch(() => {

                  });
                }else {
                  this.$router.push({path:'/userManger'})
                }
              }

            },
          //效验是否全部填写完
          checkEmpty(){
              if(this.$route.query.type==='add'){
                if(this.ruleForm.userName!==''&&this.ruleForm.userNumber!==''&&this.ruleForm.loginName!==''&&this.ruleForm.userPhone!==''){
                  this.disabled=false;
                }else {
                  this.disabled=true;
                }
              }else {
                if(this.ruleForm.userName!==this.editBasicUserInfo.userName||this.ruleForm.userNumber!==this.editBasicUserInfo.userNumber||this.ruleForm.loginName!==this.editBasicUserInfo.loginName||this.ruleForm.userPhone!==this.editBasicUserInfo.userPhone||this.ruleForm.enabled!==this.editBasicUserInfo.enabled){
                  this.disabled=false;
                }else {
                  this.disabled=true;
                }
              }
          },
          //获取编辑用户的信息
          getEditUserInfo(){
              let params={
                id:this.id,
              };
            ajaxFuncJson('/users/findUser',params).then(res=>{
              if(res.data.status==200){
                  this.ruleForm.userName=res.data.data.user.userName;
                  this.ruleForm.userNumber=res.data.data.user.userNumber;
                  this.ruleForm.loginName=res.data.data.user.loginName;
                  this.ruleForm.userPhone=res.data.data.user.userPhone;
                  this.ruleForm.enabled=res.data.data.user.enabled;
                  this.editBasicUserInfo.userName=res.data.data.user.userName;
                  this.editBasicUserInfo.userNumber=res.data.data.user.userNumber;
                  this.editBasicUserInfo.loginName=res.data.data.user.loginName;
                  this.editBasicUserInfo.userPhone=res.data.data.user.userPhone;
                  this.editBasicUserInfo.enabled=res.data.data.user.enabled;
              }else {
                this.$message({
                  message: res.data.msg,
                  type:'error'
                })
              }
            })
          },
          submitInfo(ruleForm){
              this.$refs[ruleForm].validate((valid) => {
                if (valid) {
                  if(/^[a-zA-Z0-9_]{0,14}$/.test(this.ruleForm.userNumber)){
                    if(/^[a-zA-Z0-9_]{8,16}$/.test(this.ruleForm.loginName)){
                      if(/^[1][3,4,5,7,8][0-9]{9}$/.test(this.ruleForm.userPhone)){
                        if(this.$route.query.type==='add'){
                          this.submitUseInfoAjax();
                        }else {
                          this.editSubmitUseInfoAjax();
                        }
                      }else {
                        this.$alert('手机号输入不符合规范，请重新输入', '提示', {
                          confirmButtonText: '我知道了',
                          callback: action => {

                          }
                        });
                      }
                    }else {
                      this.$alert('用户账号输入不符合规范，请重新输入', '提示', {
                        confirmButtonText: '我知道了',
                        callback: action => {

                        }
                      });
                    }
                  }else {
                    this.$alert('用户工号输入不符合规范，请重新输入', '提示', {
                      confirmButtonText: '我知道了',
                      callback: action => {

                      }
                    });
                  }
                } else {
                  return false;
                }
              });
            },
          submitUseInfoAjax(){
            ajaxFuncJson('/users/addUser',this.ruleForm).then(res=>{
              if(res.data.status==200){
                this.$router.push({path:'/saveUserInfoSuccess',query:{id:res.data.data}});
              }else if(res.data.status==403){
                this.$alert(res.data.msg, '提示', {
                  confirmButtonText: '我知道了',
                  callback: action => {

                  }
                });
              }else {
                this.$message({
                  message:res.data.msg,
                  type:'error',
                })
              }
            });
          },
          //编辑提交
          editSubmitUseInfoAjax(){
              this.ruleForm.id=this.id;
              ajaxFuncJson('/users/editUser',this.ruleForm).then(res=>{
                if(res.data.status==200){
                  if(this.isSuperManger){
                    this.$router.push({path:'/saveUserInfoSuccess',query:{type:'edit',id:this.id,runStatus:'0'}});
                  }else {
                    this.$router.push({path:'/saveUserInfoSuccess',query:{type:'edit',id:this.id}});
                  }
                }else {
                  this.$message({
                    message:res.data.msg,
                    type:'error'
                  })
                }
              });
          },
            //路由跳转
            linkIndex(){
              this.$router.push({path:'/userManger'})
            },
        },
        components: {
            topNav,
        }
    }
</script>
<style lang="scss" scope>
    @import "@/assets/css/mixin.scss";
    #editUser {
        height: 100%;
        .el-container {
            height: 100%;
            .el-main {
                width: 100% !important;
                height: 100% !important;
                margin: 0 !important;
                padding: 10px 20px 10px 20px;
                background: #f2f2f2;
                .el-row {
                    background: #fff;
                    height: 100%;
                  .mainHead{
                    margin-right: 0;
                  }
                }
            }
        }
      .demo-ruleForm.el-form .item_input{
        margin-bottom: 20px!important;
      }
    }
    .router_link:hover{
      cursor: pointer;
      color: #198cff;
    }
    .submit_userInfo{
      padding-left: 120px;
    }
    .el-form {
        margin-top: 20px;
      .el-form-item__label{
        padding: 0 10px 0 0;
      }
      .el-form-item__label:before{
        color: #f55353!important;
      }
    }
</style>



// WEBPACK FOOTER //
// src/page/systemManger/editUser.vue